import { render, staticRenderFns } from "./ColumnCardItem.vue?vue&type=template&id=1c2f16c6&scoped=true&"
import script from "./ColumnCardItem.vue?vue&type=script&lang=ts&"
export * from "./ColumnCardItem.vue?vue&type=script&lang=ts&"
import style0 from "./ColumnCardItem.vue?vue&type=style&index=0&id=1c2f16c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2f16c6",
  null
  
)

export default component.exports